import { __assign } from "tslib";
import { renderAndMountComponent, createTestHistory } from '@wix/answers-lib';
import * as React from 'react';
import { createLinkDriver } from '../../../primitives/link/link.driver';
import { Router } from 'react-router';
import { BaseNavButton } from './base-nav-button.comp';
import { getLegacyBaseDriverFromWrapper } from '../../../common/base-driver';
import { isHtmlLinkProps } from '../../../primitives/link/link.comp';
export var createNavButtonDriver = function (wrapper) {
    var base = getLegacyBaseDriverFromWrapper(wrapper, ".nav-button", BaseNavButton.name);
    var linkDriver = createLinkDriver(base.elem);
    return linkDriver;
};
export var createNavButton = function (props, type) {
    var history = createTestHistory();
    var classes = props.className + " " + type;
    var comp;
    // tslint:disable-next-line:prefer-conditional-expression
    if (isHtmlLinkProps(props)) {
        comp = React.createElement(BaseNavButton, __assign({}, props, { className: classes }), props.children);
    }
    else {
        comp = React.createElement(BaseNavButton, __assign({}, props, { className: classes }), props.children);
    }
    var elem = renderAndMountComponent(React.createElement(Router, { history: history }, comp));
    return createLinkDriver(elem);
};
//# sourceMappingURL=base-nav-button.driver.js.map